"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Svg24EyeHiddenLine = function Svg24EyeHiddenLine(_ref) {
  var fill = _ref.fill,
      useDefaultColors = _ref.useDefaultColors,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "useDefaultColors", "title"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: useDefaultColors ? 'none' : fill,
    "aria-hidden": title === null || typeof title !== 'string' || title.length === 0
  }, props), _react.default.createElement("title", null, title), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.213 12C5.47 15.134 8.608 17 12 17c.282 0 .562-.013.84-.038l1.74 1.74c-.834.195-1.696.298-2.58.298-4.418 0-8.286-2.57-10.836-6.45a1 1 0 0 1 0-1.1 16.196 16.196 0 0 1 2.858-3.307L5.439 9.56A13.828 13.828 0 0 0 3.213 12zM2.707 1.293a1 1 0 0 0-1.414 1.414l.5.5L5.56 6.974l1.45 1.45 2.282 2.283 4.001 4 1.772 1.772 1.543 1.543 4.185 4.185.5.5a1 1 0 0 0 1.414-1.414l-4.267-4.267c1.704-1.115 3.196-2.65 4.396-4.477a1 1 0 0 0 0-1.098C20.286 7.57 16.418 5 12 5c-1.623 0-3.171.347-4.608.978L2.707 1.293zM15 12a3 3 0 0 0-4.293-2.708L8.935 7.521A9.329 9.329 0 0 1 12 7c3.392 0 6.53 1.865 8.787 5-1.086 1.507-2.374 2.721-3.797 3.575l-2.282-2.282c.187-.391.292-.83.292-1.293z",
    fill: useDefaultColors ? '#191919' : fill
  }));
};

Svg24EyeHiddenLine.propTypes = {
  title: _propTypes.default.string,
  fill: _propTypes.default.string,
  useDefaultColors: _propTypes.default.bool
};
var _default = Svg24EyeHiddenLine;
exports.default = _default;